import React from 'react';

type MenuContainerProps = {
	children: React.ReactNode;
	blockClass?: string;
	componentId?: string;
};

const MenuContainerNav = ({ children, blockClass, componentId }: MenuContainerProps) => {
	return (
		<nav
			data-selection={componentId}
			className={`vtex-menu-2-x-menuContainerNav menuContainerNav vtex-menu-2-x-menuContainerNav--${blockClass} menuContainerNav--${blockClass}`}
		>
			{children}
		</nav>
	);
};

export default MenuContainerNav;
